import _find from 'lodash/find';
import _findIndex from 'lodash/findIndex';
import _isEmpty from 'lodash/isEmpty';
import React from 'react';
import { Button } from 'antd';
import { Link } from 'react-router-dom';
import { reverse } from 'named-urls';
import routes from '@achievable-me/tundra-wizard/routes';
import MediaQuery from 'react-responsive';
import ContentProgressTreemap from '$components/ProductDashboard/ContentProgressTreemap';
import DashboardHeader from '$components/ProductDashboard/DashboardHeader';
import ContentPreloader from '$components/student/ContentPreloader';
import { checkProductSlug } from '$lib/checkProductSlug';
import styles from './styles.scss';

const ContentProgress = (props) => {
  const { flatContent, inflatedContent, product } = props;
  const { slug: productSlug } = product;
  const { showPracticeExams } = checkProductSlug(productSlug);

  const nextContent = _find(
    flatContent,
    (contentInstance) => !contentInstance.completedAt && _isEmpty(contentInstance.content)
  );
  const nextIndex = _findIndex(flatContent, nextContent);

  const header = 'Content progress';
  const subheader = (
    <>
      <MediaQuery maxDeviceWidth={575}>tap on chart</MediaQuery>
      <MediaQuery minDeviceWidth={576}>hover over chart</MediaQuery>
    </>
  );

  const buttonPrefix = nextIndex === 1 ? 'Start' : 'Next';

  return (
    <div>
      <DashboardHeader header={header} subheader={subheader} />
      <div className={styles.chart}>
        {nextContent ? (
          <Link to={nextContent.path}>
            <ContentPreloader uuid={nextContent.uuid} />
            <Button
              data-aaa="nextContentButton"
              data-product-slug={productSlug}
              type="primary"
              ghost
              className={styles.button}
            >
              {buttonPrefix} &rarr; {nextContent.title}
            </Button>
          </Link>
        ) : showPracticeExams ? (
          <Link to={reverse(routes.study.exams, { productSlug })}>
            <Button
              data-aaa="nextContentButton"
              data-product-slug={productSlug}
              type="primary"
              ghost
              className={styles.button}
            >
              Take practice exams &rarr;
            </Button>
          </Link>
        ) : (
          <Button type="primary" ghost disabled className={styles.button}>
            You&apos;ve completed all the content!
          </Button>
        )}
        <ContentProgressTreemap inflatedContent={inflatedContent} />
      </div>
    </div>
  );
};

export default ContentProgress;
